module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUBAMAAAB/pwA+AAAAAXNSR0IB2cksfwAAAA9QTFRFAAAAIHX/H3b/H3b/H3b/q3c8NwAAAAV0Uk5TAGDv8P9iTWgfAAAAWElEQVR4nGMQUmQAAyBt4iIAYjG6OAGZjiCmiIszEIOEGV2AImACKgAiIXywMEQQLAwRBAtDBcHCEEFkJpIChDYkwxBWIFmM5By4I50QTndmEDaEmC5sCABRCRgrEVmTlgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/compose-alert--channels--exit@2x.png
// module id = 758
// module chunks = 0